import React from "react";
import { Row, Col, Container, CardBody, Card } from "reactstrap";
import { Link } from "react-router-dom";
import { AvForm } from "availity-reactstrap-validation";
import CMSLogo from "../../assets/images/long-logo.svg";
import { FaHome } from "react-icons/fa";


const LinkExpired = (props) => {
  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <FaHome size={32} />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center">{/* div for logo etc */}</div>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody className="p-5">
                  <Link to="/" className="mb-2 d-block auth-logo">
                    <img
                      style={{ marginLeft: "auto", marginRight: "auto" }}
                      src={CMSLogo}
                      alt=""
                      height="40"
                      className="logo logo-dark"
                    />
                  </Link>
                  <div className="text-center mt-3">
                    <h5
                      style={{
                        color: "#000000 !important",
                        fontSize: 15,
                        margin: 0,
                      }}
                    >
                      RESET PASSWORD
                    </h5>
                    <p
                      style={{ color: "#000000 !important" }}
                      className="text-muted mb-2"
                    >
                      The password reset link has expired. Please
                    </p>
                    <div className="text-center text-decoration-underline">
                      <Link to="/reset-password" className="text-dark">
                        Request for a new link
                      </Link>
                    </div>
                  </div>
                  <div className="p-2 mt-4">
                    <AvForm className="form-horizontal">
                      <div className="mt-3 text-center text-decoration-underline">
                        <Link to="/" className="text-dark">
                          Back to login
                        </Link>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default LinkExpired;
